import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addQuestionsToSurveyBankQuestionBank, AddQuestionToSurveyBankQuestionBankProps } from ".";

export function useAddQuestionsToSurveyBankQuestionBank() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationKey: ["addQuestionsToSurveyBankQuestionBank"],
        mutationFn: async (body: AddQuestionToSurveyBankQuestionBankProps[]) => {
            const { data, error } = await addQuestionsToSurveyBankQuestionBank(body);
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return data;
        },
        onSuccess: (_data) => {
            queryClient.invalidateQueries({ queryKey: ["surveyBank"] })
        }
    });
}
